import { Component, Input } from '@angular/core';
import { User, UserSwitcherService } from 'taxtank-core';
import { BaseComponent } from '@shared/component/base/base.component';

/**
 * employee under his client account
 * includes control elements to end a session
 */
@Component({
  selector: 'app-impersonator',
  templateUrl: './impersonator.component.html',
  styleUrls: ['./impersonator.component.scss'],
  standalone: false
})
export class ImpersonatorComponent extends BaseComponent {
  @Input() impersonated: User;

  constructor(private userSwitcherService: UserSwitcherService) {
    super();
  }

  reset(): void {
    this.userSwitcherService.reset();
  }
}
